import { inject } from "@angular/core";
import type { ResolveFn } from "@angular/router";
import { IntegrationsService } from "@kno2/data-access/integrations";

export const useIntegrationDocumentTypes: ResolveFn<boolean> = async () => {
    const integrationsService = inject(IntegrationsService);

    const capabilities = await integrationsService.getCapabilitiesAsync();
    const useIntegrationDocumentTypes = capabilities?.capabilities?.find((c) => c.display === "documentTypeLookup")?.reference.includes("integrations");

    return useIntegrationDocumentTypes;
};
